// components/Footer.js
export const Footer = () => {
    const footerSections = [
        {
            title: 'The Good',
            links: [
                { text: 'Home', href: '#' },
                { text: 'About', href: '#' },
                { text: 'Features', href: '#' }
            ]
        },
        {
            title: 'The Boring',
            links: [
                { text: 'Terms (Soon!)', href: '#' },
                { text: 'Privacy', href: '#' },
                { text: 'Security', href: '#' }
            ]
        },
        {
            title: 'The Cool',
            links: [
                { text: 'X', href: '#' },
                { text: 'Instagram', href: '#' }
            ]
        }
    ]

    return (
        <footer className="py-20 px-6 bg-black text-white">
            <div className="max-w-7xl mx-auto">
                <div className="flex items-center gap-2 mb-20">
                    <div className="w-8 h-8 bg-white rounded-lg"></div>
                    <span className="font-serif text-xl">SpellTree</span>
                </div>
                <div className="grid grid-cols-3 gap-20 mb-40">
                    {footerSections.map((section, index) => (
                        <div key={index}>
                            <h3 className="text-lg mb-8">{section.title}</h3>
                            <ul className="space-y-4">
                                {section.links.map((link, i) => (
                                    <li key={i}>
                                        <a href={link.href} className="text-gray-400 hover:text-white transition-colors">
                                            {link.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                {/* <h2 className="font-serif text-[12rem] leading-none">SpellTree</h2> */}
            </div>
        </footer>
    )
}